import { render, staticRenderFns } from "./co.vue?vue&type=template&id=98e73dfe"
import script from "./co.vue?vue&type=script&lang=js"
export * from "./co.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports